import { select } from "redux-saga/effects";
import { CommerceToolsApi } from "@grandvisionhq/commercetools";
import { PrescriptionValidationStepContainer } from "../../../../../../../../steps/PrescriptionValidationStep/steps/PrescriptionValidationStep/PrescriptionValidationStepContainer.js";
import { isNewPrescriptionAndUpload } from "../../../../../../../../utils/utils/is-new-prescription-upload.js";
import "../../../../../../../state/actions.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getIsExtraValidationStepEnabled, getPrescriptionType, getVerificationAllowed } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
const prescriptionValidationStepBase = {
  onNext,
  stepStatus: (s) => {
    const isStepEnabled = getIsExtraValidationStepEnabled(s);
    const prescriptionType = getPrescriptionType(s);
    const isNewPrescription = CommerceToolsApi.isNewPrescription(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType);
    if (!isStepEnabled) {
      return "hidden";
    }
    return isNewPrescription ? "active" : "skip";
  },
  view: PrescriptionValidationStepContainer
};
function* onNext() {
  const isVerificationAllowed = yield select(
    getVerificationAllowed
  );
  return !isVerificationAllowed;
}
export {
  prescriptionValidationStepBase
};
//# sourceMappingURL=prescription-validation.js.map
